import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DropdownItemModel } from 'ng-voxloud';
import { Subscription } from 'rxjs';
import { IPhoneCallTag } from 'voxloud-types/dist/models';

@Component({
  selector: 'filter-tag',
  templateUrl: './filter-tag.component.html',
  styleUrls: ['./filter-tag.component.scss'],
  providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => FilterTagComponent),
        multi: true
      }
    ]
})
export class FilterTagComponent implements ControlValueAccessor {
  @Input() set tags(tags: IPhoneCallTag[]) {
    this.allTags = tags.map(tag => {
      return {
        item_id: String(tag.id),
        item_name: tag.value,
        data: tag
      };
    });
  }
  
  public language: string = 'en';

  public selectedTagsControl: FormControl = new FormControl([]);
  public allTags: DropdownItemModel[] = [];
  public onChange: any = (_) => { };
  public onTouch: any = () => { };
  
  private subscriptions: Subscription[] = [];

  constructor(
    private translateService: TranslateService
  ) {}

  ngOnInit() {
    this.language = this.translateService.currentLang || this.translateService.getDefaultLang();
    this.subscriptions.push(
      this.translateService.onLangChange.subscribe((lang) => {
        this.language = lang.lang;
      })
    );
    this.subscriptions.push(
      this.selectedTagsControl.valueChanges.subscribe(((v: DropdownItemModel[]) => {
        setTimeout(() => {
          const selectedTags = v?.map(item => item.data.id);
          this.onChange(selectedTags || []);
        }, 0);
      }))
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  writeValue(obj: string): void {
    if (obj && obj.length > 0) {
      // Workaround for changing property 2 times in a tick.
      setTimeout(() => {
        const selectedTags = this.allTags.filter(tag => obj.includes(tag.data.id));
        this.selectedTagsControl.setValue(selectedTags);
        this.onChange(selectedTags.map(tag => tag.data.id), { emitEvent: false });
      }, 0);
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }
}
